import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { Checkbox } from "../checkbox/checkbox.es.js";
import { MultiSelectOptionWrapper } from "./multi-select-option.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  highlighted: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onMouseEnter: PropTypes.func,
  selected: PropTypes.bool,
  wrap: PropTypes.bool
};
const defaultProps = {
  highlighted: false,
  id: void 0,
  onFocus: void 0,
  onMouseEnter: void 0,
  selected: false,
  wrap: false
};
const MultiSelectOption = forwardRef(
  ({
    children,
    highlighted,
    id,
    onChange,
    onFocus,
    onMouseEnter,
    selected,
    wrap,
    ...restProps
  }, ref) => /* @__PURE__ */ jsx(
    MultiSelectOptionWrapper,
    {
      "aria-selected": selected,
      $highlighted: highlighted,
      id,
      onMouseEnter,
      role: "option",
      children: /* @__PURE__ */ jsx(
        Checkbox,
        {
          ref,
          checked: selected,
          disableHoverStyles: true,
          noWrap: !wrap,
          onChange,
          onFocus,
          paddingX: "medium",
          paddingY: "small",
          tabIndex: -1,
          ...restProps,
          children
        }
      )
    }
  )
);
MultiSelectOption.propTypes = propTypes;
MultiSelectOption.defaultProps = defaultProps;
export {
  MultiSelectOption
};
